'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var monthValues = {
    1: '01',
    2: '02',
    3: '03',
    4: '04',
    5: '05',
    6: '06',
    7: '07',
    8: '08',
    9: '09',
    10: '10',
    11: '11',
    12: '12'
};

exports.default = monthValues;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/month/monthValues.js
// module id = 1376
// module chunks = 0